<template>
  <DonutChartTemplate
    v-if="higherEducationInstitutionDistribution"
    :chartMainData="getCurrentChartMainData"
    :chartHeight="408"
    :chartWidth="408"
    :keyNamesForChartMainData="keyNamesForChartMainData"
    chartMarginTopPosition="40px"
    currentStaticValue="higherEducationInsitutions"
    chartSeriesYKey="totalUsers"
    chartTitle="Распределение пользователей по вузам"
  />
</template>
<script>
import DonutChartTemplate from "./templates/DonutChartTemplate";
import { graphQueryConstructor } from "@/tools/graphQueryConstructor";
import { gQueryOptionsTemplate } from './chartHelper';
import gql from 'graphql-tag';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "HighEducationChart",
  components: {
    DonutChartTemplate,
  },
  props: {
    apolloSearchString: {
      type: String,
      default: "",
    },
    userSearchFilters: {
      type: Object,
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
  },
  apollo: {
    higherEducationInstitutionDistribution: {
      query() {
        return gql(graphQueryConstructor(
          ...gQueryOptionsTemplate(
              this.hasUserContactsAccess,
              this.apolloSearchString,
              this.userSearchFilters,
              this.selectedTags,
              "higherEducationInstitutionDistribution",
              this.year,
            )
        ));
      },
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
      higherEducationInstitutionDistribution: null,
      keyNamesForChartMainData: {
        higherEducationInsitutions: {
          listItemTitle: 'name',
          listTotalItemCount: 'totalUsers',
        },
      },
    };
  },
  methods: {
    yearUpdate(value) {
      this.year = value;
    },
  },
  computed: {
    ...mapGetters('auth', ['hasUserContactsAccess']),
    getCurrentChartMainData() {
      if (this.higherEducationInstitutionDistribution) {
        const higherEducationInsitutions = this.higherEducationInstitutionDistribution.higherEducationInsitutions.map((item, index) => {
          return  {name: item.foreignPlaceName, totalUsers: item.totalUsers};
        });

        return {
          higherEducationInsitutions,
        };
      } else {
        return {};
      }
    },
  },
}; 
</script>
<style>
</style>